export let apiURL = process.env.REACT_APP_URL || "https://api-teste.gestaotributaria.com.br";
